<template>
  <section class="container">
     <el-carousel :interval="4000" indicator-position="outside" height="112px">
        <el-carousel-item class="banner">
          <img class="banner-img" :src="banner1">
        </el-carousel-item>
        <div class="headerFontRecuit">
          <span class="headerFontRecuitOne">魅力城轨 &nbsp;  美丽徐州</span>
        </div>
      </el-carousel>
    <div class="pathInfo">当前位置：人才招聘 > 岗位详情 > 申请职位</div>
    <div class="resume-success-bg" :style="{'min-height': bgHeight, 'backgroundImage': 'url(' + img3 + ')'}">
      <div class="content">
        <img :src="success">
        <h3>感谢您的投递！</h3>
        <!--
        <span>您的简历已提交，我们将尽快进行资格审查，并根据该岗位的报名情况确定面试名单。进入面试的人员，我们将于1个月内通知。若您未收到通知，请您选择其他就业机会，感谢您对徐州地铁的支持。</span>
        -->
        <span>您的简历已提交，感谢您对徐州地铁的支持。</span>
      </div>
    </div>
  </section>
</template>
<script>
import Banner1 from 'assets/PC/banner_zpxqy.png'
import success from 'assets/PC/digndantijiao_icon_tjcg.png'
import img3 from 'assets/PC/bg_zpxqy.png'
export default {
  data: () => {
    return {
      bgHeight:'350px',
      bgHeightContent:'330px',
      img3:img3,
      banner1: Banner1,
      success
    }
  },
  mounted() {
    window.onresize = () => {
      return (() => {
        let he = document.body.clientHeight - 65 - 270
        if(he<350){
          he = 350
        }
        this.bgHeight = he + 'px'
        this.bgHeightContent = (he - 10) + 'px'
      })()
    }
  },
  created() {
    this.initHeight()
  },
  methods:{
    initHeight() {
      let he = document.body.clientHeight - 245
      if(he<350){
        he = 350
      }
      this.bgHeight = he + 'px'
      this.bgHeightContent = (he - 10) + 'px'
    }
  }
}
</script>
<style>
  .pathInfo{
    font-size: 12px;
    border-bottom: #eeeeee solid 1px;
    height: 1.8rem;
    width: 65%;
    margin: 20px auto 0;
  }
   .banner-img{
    width: 100%;
    height: 110px !important;
  }
  .headerFontRecuit {
    position: absolute;
    left: 68%;
    z-index: 99;
    top: 28%;
    color: white;
    text-align: center
  }
  .headerFontRecuitOne {
    margin-bottom: 20px;
    display: inline-block;
    font-size: 1.6em;
  }
  .footer-wrapper{
    margin-top: 0;
  }
  .content{
    margin-top: 10%;
  }
</style>




// WEBPACK FOOTER //
// src/components/resume/success.vue